import { render, staticRenderFns } from "./ServiceOrderLineItemsComponent.vue?vue&type=template&id=2a72bbfc&"
import script from "./ServiceOrderLineItemsComponent.vue?vue&type=script&lang=js&"
export * from "./ServiceOrderLineItemsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports